"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_INFO = void 0;
var PRODUCT_INFO = {
  TEXT__IMPORT_TYPE: 'singleProductInfo-span-importType',
  INPUT__NAME: 'singleProductInfo-input-name',
  INPUT__SKU: 'singleProductInfo-input-sku',
  INPUT__PRICE: 'singleProductInfo-input-price',
  INPUT__COGS: 'singleProductInfo-input-cogs',
  INPUT__QUANTITY_INCREMENT: 'singleProductInfo-input-quantityIncrement',
  INPUT__MINIMUM_QUANTITY: 'singleProductInfo-input-minimumQuantity',
  LABEL__MARKET_PRICE: 'singleProductInfo-label-marketPrice',
  LABEL__PRICE_UNIT: 'singleProductInfo-label-priceUnitDifferentFromSalesUnit',
  BUTTON__UPLOAD_IMAGE: 'singleProductInfo-button-uploadImage',
  BUTTON__REMOVE_IMAGE: 'singleProductInfo-button-removeImage',
  BUTTON__CATEGORY: 'singleProductInfo-button-category',
  BUTTON__SALES_UNIT: 'singleProductInfo-button-salesUnit',
  BUTTON__PRICE_UNIT: 'singleProductInfo-button-priceUnit',
  BUTTON__SAVE_CHANGES: 'singleProductInfo-button-saveChanges',
  TEXTAREA__DESCRIPTION: 'singleProductInfo-textarea-description'
};
exports.PRODUCT_INFO = PRODUCT_INFO;